export default __webpack_public_path__ + "static/char-thumb-09-416d6f95e7bef44301089b55ee58c9b4.png";